import { DomainConfigChange } from './domain-config-constants';

const FIELD_LABELS: Record<string, string> = {
  client_type: 'Client type',
  vertical: 'Vertical',
  journey_milestones: 'Journey milestones'
};

const formatValue = (value: unknown): string => {
  if (value === null || value === undefined) return 'none';
  if (typeof value === 'string') return value;
  return JSON.stringify(value);
};

/** One human-readable line for a change-log entry, e.g. "Vertical: retail → health". */
export const formatChangeSummary = ({
  field_name: fieldName,
  summary,
  old_value: oldValue,
  new_value: newValue
}: DomainConfigChange): string => {
  const label = FIELD_LABELS[fieldName] ?? fieldName;
  return `${label}: ${summary ?? `${formatValue(oldValue)} → ${formatValue(newValue)}`}`;
};
